/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {useLocation} from "react-router";
import {NavLink}  from "react-router-dom";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl, checkIsActive} from "../../../../_helpers";
import {useSelector} from "react-redux";

export function AsideMenuList({ layoutProps }) {
	const {user} = useSelector(state => state.auth);
	const adminobject = user.userData;
	let admin_role = ''
	if(adminobject.admin_role) { admin_role = adminobject.admin_role;}
	let issuperadmin=false;
	if(admin_role==='superadmin')
	{
		issuperadmin=true;
	}

	const location = useLocation();
	const getMenuItemActive = (url) => {
    return checkIsActive(location, url)
        ? " menu-item-active menu-item-open "
        : "";
	};

	return (
		<>
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
			<li
				className={`menu-item ${getMenuItemActive("/dashboard")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/dashboard">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Dashboard</span>
				</NavLink>
			</li>
			{ issuperadmin? 
			<li
				className={`menu-item ${getMenuItemActive("/admin")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/admin">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Admin</span>
				</NavLink>
			</li>  
			:
			<>
			</>
			}
			
			<li
				className={`menu-item ${getMenuItemActive("/user")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/user">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">App Users</span>
				</NavLink>
			</li>
			
			<li
				className={`menu-item ${getMenuItemActive("/category")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/category">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Category</span>
				</NavLink>
			</li>
			
			{/* Subcategory removed */}
			
			<li
				className={`menu-item ${getMenuItemActive("/business")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/business/">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Business</span>
				</NavLink>
			</li>
			{ issuperadmin? 
			<li
				className={`menu-item ${getMenuItemActive("/business/reported")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/business/reported">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Reported Business</span>
				</NavLink>
			</li>  
			:
			<>
			</>
			}
			<li
				className={`menu-item ${getMenuItemActive("/subscription")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/subscription/">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Subscription</span>
				</NavLink>
			</li>
			
			<li
				className={`menu-item ${getMenuItemActive("/advertisement")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/advertisement/">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Advertisements</span>
				</NavLink>
			</li>
			<li
				className={`menu-item ${getMenuItemActive("/location/countries")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/location/countries">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Countries</span>
				</NavLink>
			</li>

			<li
				className={`menu-item ${getMenuItemActive("/location/states")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/location/states">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">States</span>
				</NavLink>
			</li>

			<li
				className={`menu-item ${getMenuItemActive("/location/cities")}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/location/cities">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
					</span>
					<span className="menu-text">Cities</span>
				</NavLink>
			</li>
			
			<li className={`menu-item d-lg-none`} aria-haspopup="true" >
                <NavLink className="menu-link" to="/logout">
                    <span className="svg-icon menu-icon">
                        <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
                    </span>
                    <span className="menu-text">Logout</span>
                </NavLink>
            </li>

		</ul>
		</>
	);
}